import type { FC } from 'react'

import { sanitizeAndInsertTargetBlank } from '@skytech/utils/html-sanitization'
import { twJoin } from 'tailwind-merge'

import { useAppContext } from '@/App.context'
import Page from '@/components/page/Page'
import useSetup from '@/hooks/setup'

import { Translation } from '../i18n/Translation'

import { AssetList } from './AssetList'

import './index.scss'

const MyAssetsPage: FC = () => {
  const setup = useSetup()
  const { whiteLabel } = useAppContext()
  const repairReturnText = setup?.repair_return_text

  return (
    <Page className="injury-report">
      <h2 className="text-2xl">
        <Translation id="My assets" />
      </h2>

      {repairReturnText && (
        <div className="text-wrapper">
          <p
            className={twJoin('block', whiteLabel)}
            dangerouslySetInnerHTML={{ __html: sanitizeAndInsertTargetBlank(repairReturnText) }}
          />
        </div>
      )}
      <AssetList />
    </Page>
  )
}

export default MyAssetsPage
